module.exports = __webpack_public_path__ + "img/hurricane-01.f2fabe37.svg";